/* Slope Masks theme runtime: announcement countdown, header, cart drawer (Shopify Cart API),
   reviews, homepage proof, product page. Configuration arrives in window.STORE (theme settings,
   emitted by layout/theme.liquid) and window.STORE_PRODUCT (the product section). */
(function () {
  "use strict";
  const S = window.STORE;
  if (!S) return;
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const money = (n) => S.CURRENCY + Number(n).toFixed(2);
  /* Whole amounts without cents ($15), otherwise two decimals ($15.50). */
  const moneyShort = (n) => { const c = Math.round(Number(n) * 100); return S.CURRENCY + (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2)); };
  const cents = (c) => money(c / 100);
  /* nb: glue a short phrase with non-breaking spaces so prices and key pairs never split across lines. */
  const nb = (s) => String(s).replace(/ /g, " ");
  const SEP = '<i class="sep" aria-hidden="true"></i>';
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  /* Display names may carry a trademark sign; it renders small (.tm). */
  const tmHtml = (t) => esc(t).replace(/\u2122/g, '<span class="tm">\u2122</span>');
  const img = (name) => (/^(https?:)?\/\//.test(name) ? name : S.IMG_BASE + name + ".webp");
  /* Shopify CDN resize: replaces any width already on the URL (theme URLs come from image_url and carry one). */
  const thumb = (url, w) => {
    if (!url || !/cdn\.shopify\.com|\/cdn\/shop\//.test(url)) return url;
    const u = url.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "");
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  };
  const srcset = (url) => [600, 900, 1400].map((w) => `${thumb(url, w)} ${w}w`).join(", ");
  const page = document.body.dataset.page;
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const ICONS = {
    check: '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7"/></svg>',
    truck: '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>',
    play: '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>',
  };
  const stars = (n) => "★".repeat(Math.round(n)) + "☆".repeat(5 - Math.round(n));
  /* Trail-difficulty markers for the three pack tiers: green circle, blue square, black diamond. */
  const MARKERS = ["green", "blue", "black"];
  const PRODUCT_LIST = Object.keys(S.PRODUCTS).map((k) => S.PRODUCTS[k]).filter(Boolean);
  /* Add-ons never count as masks: not in the mask count, the free-shipping bar, pack savings or the upsell.
     Shipping protection is one of them, with its own row; the rest (S.ADDONS) keep the generic toggle list. */
  const PROTECT = S.PROTECT && S.PROTECT.enabled && S.PROTECT.variantId ? S.PROTECT : null;
  const PROTECT_ID = PROTECT ? String(PROTECT.variantId) : "";
  /* Theme settings > Products > Display name: cart lines show it instead of the Shopify title. */
  const nameFor = (l) => { const p = PRODUCT_LIST.find((x) => String(x.productId) === String(l.product_id)); return p ? p.name : l.product_title; };
  const ADDON_IDS = (S.ADDONS || []).map((a) => String(a.variantId)).concat(PROTECT_ID ? [PROTECT_ID] : []);
  const store = (area) => ({
    get(k) { try { return window[area].getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window[area].setItem(k, v); } catch (e) { /* storage blocked: behave as unset */ } },
    del(k) { try { window[area].removeItem(k); } catch (e) { /* ignore */ } },
  });
  const SS = store("sessionStorage"), LS = store("localStorage");

  /* ---------- sale state ---------- */
  /* Real pack savings, computed from the configured prices: the best tier's percent off the sum of singles, rounded down. */
  /* The one saving number used everywhere (price pill, offer cards, sticky bar, announcement): pack price against the
     sum of single prices, in whole percent, always rounded down. */
  const savePct = (b) => { const wasC = Math.round(b.qty * S.BUNDLES[0].price * 100), nowC = Math.round(b.price * 100); return wasC > nowC ? Math.floor(((wasC - nowC) * 100) / wasC) : 0; };
  const PACK_PCT = Math.max(0, ...S.BUNDLES.filter((b) => b.qty > 1).map(savePct));
  /* Free-shipping math, all from settings: shipping on a mask subtotal, the smallest pack that ships free,
     and what N masks cost delivered when bought as N separate single orders. */
  const shipOn = (price) => (price >= S.FREE_SHIPPING_THRESHOLD ? 0 : S.SHIPPING_FLAT);
  const FREE_N = (S.BUNDLES.find((b) => b.price >= S.FREE_SHIPPING_THRESHOLD) || { qty: 2 }).qty;
  const deliveredSingles = (n) => n * (S.BUNDLES[0].price + shipOn(S.BUNDLES[0].price));
  const BEST_PER = Math.min(...S.BUNDLES.map((b) => b.price / b.qty));
  const FREE_LINE = `Free US shipping on ${FREE_N}+ masks`;
  /* Theme settings > Urgency: a per-visitor one-hour countdown. It bypasses Launch mode and the dated sale. */
  function urgencyEnd() {
    let t = parseInt(LS.get("slopeTimerEnd"), 10);
    if (!t || isNaN(t) || t <= Date.now()) { t = Date.now() + 36e5; LS.set("slopeTimerEnd", String(t)); }
    return new Date(t);
  }
  function saleEnd() {
    if (S.URGENCY_TIMER) return urgencyEnd();
    if (!S.SALE_END) return null;
    let end = new Date(S.SALE_END);
    if (isNaN(end)) return null;
    if (end < new Date()) {
      if (S.LAUNCH_MODE || !S.PREVIEW_ROLLING_SALE) return null;
      end = new Date(); end.setHours(23, 59, 59, 0);
    }
    return end;
  }
  let SALE = saleEnd();
  const saleActive = !!SALE;

  /* ---------- announcement bar with countdown ---------- */
  function renderAnnounce() {
    const el = $("#announce");
    if (!el) return;
    if (!saleActive) {
      el.hidden = false; el.className = "announce";
      el.innerHTML = `<span>${nb("Free shipping on 2 or more")}${SEP}${nb("30-day returns")}</span>`;
      return;
    }
    const lastDay = (SALE - new Date()) < 24 * 3600 * 1000;
    el.hidden = false; el.className = "announce sale" + (lastDay ? " last" : "") + (S.URGENCY_TIMER ? " today" : "");
    let chip = lastDay ? `<span class="chip urgent">Last day</span>` : `<span class="chip sale">${S.SALE_NAME}</span>`;
    let label = lastDay ? nb(`Up to ${S.SALE_PERCENT}% off packs ends tonight`) : nb(`Up to ${S.SALE_PERCENT}% off packs`);
    if (S.URGENCY_TIMER) { chip = `<span class="chip urgent">Sale ends today</span>`; label = nb(`Up to ${PACK_PCT}% off packs`); }
    el.innerHTML = `${chip}<span class="rot" aria-live="off"><span class="on">${label}</span><span>${nb(`Free shipping on ${FREE_N}+ masks`)}</span></span><span class="tpill" aria-label="time left">00:00:00</span>`;
    const tp = $(".tpill", el);
    const tick = () => {
      if (S.URGENCY_TIMER && SALE <= new Date()) SALE = urgencyEnd();
      let ms = Math.max(0, SALE - new Date());
      const d = Math.floor(ms / 864e5); ms -= d * 864e5;
      const h = Math.floor(ms / 36e5); ms -= h * 36e5;
      const m = Math.floor(ms / 6e4); ms -= m * 6e4;
      const s = Math.floor(ms / 1e3);
      const hms = [h, m, s].map((x) => String(x).padStart(2, "0")).join(":");
      tp.textContent = (d ? d + "d " : "") + hms;
      const pl = $("#sale-line b");
      if (pl) pl.textContent = [h + d * 24, m, s].map((x) => String(x).padStart(2, "0")).join(":");
    };
    tick(); setInterval(tick, 1000);
    /* The sale line and the free-shipping line share one slot and swap every few seconds (no fade under reduced motion). */
    const rot = $$(".rot > span", el); let ri = 0;
    setInterval(() => { rot[ri].classList.remove("on"); ri = (ri + 1) % rot.length; rot[ri].classList.add("on"); }, reduceMotion ? 6000 : 4000);
  }

  /* ---------- header, menu, config-driven numbers ---------- */
  function renderNav() {
    const menu = $("#menu");
    const open = $("#menu-open");
    if (menu && open) {
      open.addEventListener("click", () => { menu.classList.add("open"); document.body.classList.add("lock"); });
      menu.addEventListener("click", (e) => { if (e.target.dataset.close !== undefined || e.target.tagName === "A") { menu.classList.remove("open"); document.body.classList.remove("lock"); } });
    }
    $$("[data-free-ship]").forEach((e) => (e.textContent = money(S.FREE_SHIPPING_THRESHOLD)));
    $$("[data-ship-flat]").forEach((e) => (e.textContent = money(S.SHIPPING_FLAT)));
    $$("[data-two-for]").forEach((e) => (e.textContent = nb("2 for " + money(S.BUNDLES[1].price))));
    $$("[data-free-n]").forEach((e) => (e.textContent = FREE_N));
  }

  /* ---------- toast ---------- */
  let toastT;
  window.__toast = function (msg) {
    const t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("on"); clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove("on"), 2200);
  };

  /* ---------- cart (Shopify Cart API) ---------- */
  let CART = null;
  const routes = S.routes || { cart_url: "/cart", cart_add_url: "/cart/add", cart_change_url: "/cart/change" };
  const headers = { "Content-Type": "application/json", Accept: "application/json" };
  async function cartFetch() { const r = await fetch(routes.cart_url + ".js", { cache: "no-store", headers }); CART = await r.json(); return CART; }
  const post = (url, body) => fetch(url + ".js", { method: "POST", headers, body: JSON.stringify(body) });
  /* After every cart read: protection is one per order and only with masks; "prechecked" adds it once per session
     unless the customer switched it off. Returns true when it changed the cart. */
  let normalizing = false;
  async function normalizeProtection() {
    if (!PROTECT || normalizing || !CART) return false;
    normalizing = true;
    try {
      const p = CART.items.find(isProtect);
      const masks = maskCount();
      if (p && !masks) { await post(routes.cart_change_url, { id: p.key, quantity: 0 }); await cartFetch(); return true; }
      if (p && p.quantity > 1) { await post(routes.cart_change_url, { id: p.key, quantity: 1 }); await cartFetch(); return true; }
      if (!p && masks > 0 && PROTECT.defaultOn && !SS.get("slopeProtectOff") && !SS.get("slopeProtectAuto")) {
        SS.set("slopeProtectAuto", "1");
        await post(routes.cart_add_url, { items: [{ id: Number(PROTECT_ID), quantity: 1 }] }); await cartFetch(); return true;
      }
      return false;
    } finally { normalizing = false; }
  }
  async function cartGet() { await cartFetch(); await normalizeProtection(); return CART; }
  async function setProtection(on) {
    if (!PROTECT) return;
    const p = CART && CART.items.find(isProtect);
    if (on) { SS.del("slopeProtectOff"); if (!p) await cartAdd([{ id: Number(PROTECT_ID), quantity: 1 }]); }
    else { SS.set("slopeProtectOff", "1"); if (p) await cartChange(p.key, 0); }
  }
  async function cartAdd(items) {
    const r = await fetch(routes.cart_add_url + ".js", { method: "POST", headers, body: JSON.stringify({ items }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); window.__toast(e.description || "Could not add to cart."); }
    return cartGet();
  }
  async function cartChange(key, quantity) {
    await fetch(routes.cart_change_url + ".js", { method: "POST", headers, body: JSON.stringify({ id: key, quantity }) });
    return cartGet();
  }
  const isAddon = (item) => ADDON_IDS.includes(String(item.variant_id));
  const isProtect = (item) => !!PROTECT_ID && String(item.variant_id) === PROTECT_ID;
  const maskLines = () => (CART ? CART.items.filter((i) => !isAddon(i)) : []);
  const maskCount = () => maskLines().reduce((n, l) => n + l.quantity, 0);
  function bundlePrice(n) {
    const t3 = S.BUNDLES[2], t2 = S.BUNDLES[1], t1 = S.BUNDLES[0];
    let total = Math.floor(n / 3) * t3.price; const r = n % 3;
    if (r === 2) total += t2.price; else if (r === 1) total += t1.price;
    return Math.round(total * 100) / 100;
  }
  function findVariant(vid) {
    for (const p of PRODUCT_LIST) { const v = p.variants.find((x) => String(x.id) === String(vid)); if (v) return { product: p, variant: v }; }
    return null;
  }
  async function addToCart(items) {
    await cartAdd(items);
    renderCartCount(true); renderDrawer(); openDrawer();
  }
  function renderCartCount(bump) {
    const c = $("#cart-count"); if (!c) return;
    const n = CART ? maskCount() : (S.CART_COUNT || 0);
    c.textContent = n; c.classList.toggle("on", n > 0);
    if (bump && n > 0 && !reduceMotion) { c.classList.remove("bump"); void c.offsetWidth; c.classList.add("bump"); }
  }

  /* ---------- drawer ---------- */
  function buildDrawer() {
    const d = $("#cart-drawer"); if (!d) return;
    d.addEventListener("click", (e) => { if (e.target.closest("[data-close]")) closeDrawer(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeDrawer(); const lb = $("#lightbox"); if (lb) lb.classList.remove("open"); } });
    const openBtn = $("#cart-open");
    if (openBtn) openBtn.addEventListener("click", async (e) => { e.preventDefault(); await cartGet(); renderDrawer(); openDrawer(); });
  }
  function openDrawer() { const d = $("#cart-drawer"); if (!d) return; d.classList.add("open"); d.setAttribute("aria-hidden", "false"); document.body.classList.add("lock"); }
  function closeDrawer() { const d = $("#cart-drawer"); if (!d) return; d.classList.remove("open"); d.setAttribute("aria-hidden", "true"); document.body.classList.remove("lock"); }
  function renderDrawer() {
    const body = $("#drawer-body"), foot = $("#drawer-foot"); if (!body || !CART) return;
    const lines = maskLines();
    const n = maskCount();
    $("#drawer-count").textContent = n ? `(${n})` : "";
    if (!n) {
      body.innerHTML = `<div class="cart-empty"><p>Your cart is empty.</p><a class="btn" href="${PRODUCT_LIST[0] ? PRODUCT_LIST[0].url : "/"}">Pick a face</a></div>`;
      foot.innerHTML = ""; return;
    }
    /* Pack math. Shopify applies the pack discounts automatically; the cart response carries them.
       If the cart has not received a discount yet (for example a discount that was paused), fall back to
       the configured pack prices and say the price is applied at checkout. */
    const fullC = lines.reduce((s, l) => s + l.original_line_price, 0);
    let discC = CART.total_discount || 0;
    let note = "";
    if (!discC && n >= 2) { discC = fullC - Math.round(bundlePrice(n) * 100); note = "Pack price is applied at checkout."; }
    const masksC = fullC - discC;
    const addonLines = CART.items.filter((l) => isAddon(l) && !isProtect(l));
    const addonsC = addonLines.reduce((s, l) => s + l.final_line_price, 0);
    const protLine = CART.items.find(isProtect);
    const protC = protLine ? protLine.final_line_price : 0;
    const threshC = Math.round(S.FREE_SHIPPING_THRESHOLD * 100);
    const shipFree = masksC >= threshC;
    const shippingC = shipFree ? 0 : Math.round(S.SHIPPING_FLAT * 100);
    const pct = shipFree ? 100 : Math.min(100, Math.round((masksC / threshC) * 100));
    const nextN = n + 1, nextDelta = Math.round((bundlePrice(nextN) - bundlePrice(n)) * 100) / 100;
    const inCart = lines.map((l) => String(l.variant_id));
    const faces = S.PRODUCTS.faces, block = S.PRODUCTS.blockhead;
    const hasBlock = block && lines.some((l) => l.product_id === block.productId);
    const upProduct = (hasBlock || !block || !block.listed) ? faces : block;
    const upVar = upProduct ? (upProduct.variants.find((v) => !inCart.includes(String(v.id)) && v.available) || upProduct.variants[0]) : null;
    const bar = shipBar(lines, n, masksC, shippingC, pct, upVar);
    body.innerHTML = `
      ${bar.html}
      ${lines.map((l) => `
        <div class="line" data-key="${l.key}"><img src="${thumb(l.image, 144) || ""}" alt="${esc(l.variant_title || nameFor(l))}" loading="lazy" width="72" height="72">
          <div class="info"><b>${tmHtml(nameFor(l))}</b><small>Face: ${l.variant_title || ""}</small>
            <div class="row"><span class="qty"><button data-q="-1" aria-label="Decrease">−</button><output>${l.quantity}</output><button data-q="1" aria-label="Increase">+</button></span>
            <span class="price">${cents(l.original_line_price)}</span></div>
            <button class="remove" data-remove>Remove</button></div></div>`).join("")}
      ${PROTECT ? protectRow(!!protLine) : ""}
      ${upVar && !bar.picker ? `<div class="upsell"><img src="${thumb(upVar.img, 128)}" alt="" width="64" height="64"><div><b>Add ${upProduct === block ? "a " + tmHtml(block.name) : upVar.name} ${nb("for " + money(nextDelta))}</b><small>${nextN === 2 ? "Unlocks the 2-pack price." : nextN === 3 ? "Unlocks the 3-pack price." : "Pack price applied automatically."}</small></div><button class="btn ghost" data-upsell="${upVar.id}">Add</button></div>` : ""}
      ${S.ADDONS && S.ADDONS.length ? `<div class="addons"><h4>Checkout add-ons</h4>${S.ADDONS.map((a) => { const on = addonLines.some((l) => String(l.variant_id) === String(a.variantId)); return `
        <div class="addon"><div><b>${a.name}</b><small>${a.desc}</small></div><div class="r"><span>+${money(a.price)}</span><button class="switch" role="switch" aria-checked="${on}" data-addon="${a.variantId}" aria-label="${a.name}"></button></div></div>`; }).join("")}</div>` : ""}`;
    foot.innerHTML = `
      <div class="totals">
        <div><span>Masks (${n})</span><span><s class="muted">${discC > 0 ? cents(fullC) : ""}</s> ${cents(masksC)}</span></div>
        ${discC > 0 ? `<div class="save"><span>Pack savings</span><span>−${cents(discC)}</span></div>` : ""}
        ${note ? `<div class="cart-note"><span></span><span>${note}</span></div>` : ""}
        ${protC ? `<div><span>${PROTECT.title}</span><span>+${cents(protC)}</span></div>` : ""}
        ${addonsC ? `<div><span>Add-ons</span><span>${cents(addonsC)}</span></div>` : ""}
        <div><span>Shipping</span><span>${shipFree ? "Free" : cents(shippingC)}</span></div>
        <div class="grand"><span>Total</span><span>${cents(masksC + protC + addonsC + shippingC)}</span></div>
      </div>
      <button class="btn accent lg block" id="checkout">Checkout${SEP}${cents(masksC + protC + addonsC + shippingC)}</button>
      <div class="secure">Secure checkout${SEP}${nb("30-day returns")}${SEP}Tracked shipping</div>`;
    body.onclick = async (e) => {
      const q = e.target.closest("[data-q]"), rm = e.target.closest("[data-remove]"), sw = e.target.closest("[data-addon]"), up = e.target.closest("[data-upsell]"), pr = e.target.closest("[data-protect]");
      const sf = e.target.closest("[data-ship-faces] .sf");
      if (sf) { await addFace(sf); renderCartCount(true); renderDrawer(); return; }
      if (pr) { pr.disabled = true; await setProtection(pr.getAttribute("aria-checked") !== "true"); renderCartCount(); renderDrawer(); return; }
      if (q) { const key = q.closest(".line").dataset.key; const l = CART.items.find((x) => x.key === key); await cartChange(key, Math.max(0, l.quantity + (+q.dataset.q))); renderCartCount(); renderDrawer(); }
      if (rm) { const key = rm.closest(".line").dataset.key; await cartChange(key, 0); renderCartCount(); renderDrawer(); }
      if (sw) { const vid = sw.dataset.addon; const l = CART.items.find((x) => String(x.variant_id) === String(vid)); if (l) await cartChange(l.key, 0); else await cartAdd([{ id: Number(vid), quantity: 1 }]); renderDrawer(); }
      if (up) { await cartAdd([{ id: Number(up.dataset.upsell), quantity: 1 }]); renderCartCount(true); renderDrawer(); }
    };
    $("#checkout").onclick = () => { location.href = "/checkout"; };
  }

  /* Free-shipping bar. Counts masks only (add-ons and protection never move it). When one more mask unlocks free shipping,
     it says what that mask costs delivered and offers a face picker with a one-tap add. */
  function shipBar(lines, n, masksC, shippingC, pct, upVar) {
    const threshC = Math.round(S.FREE_SHIPPING_THRESHOLD * 100);
    if (masksC >= threshC) return { picker: false, html: `<div class="ship-bar done"><span>${ICONS.truck}Free shipping unlocked.</span><i><b style="--w:100%"></b></i></div>` };
    const nextC = Math.round(bundlePrice(n + 1) * 100), nextShipC = nextC >= threshC ? 0 : Math.round(S.SHIPPING_FLAT * 100);
    const moreC = nextC + nextShipC - (masksC + shippingC);
    if (nextShipC === 0 && upVar) {
      /* Every face as a tile (packshot + name) in a 3-column grid; tapping a tile adds that face right away. */
      const faces = [].concat(...PRODUCT_LIST.map((p) => p.variants.filter((v) => v.available)));
      if (faces.length) {
        const tiles = faces.map((v) => `<button type="button" class="sf" data-face="${v.id}" aria-label="Add ${esc(v.name)} for ${cents(moreC)}"><span class="im"><img src="${thumb(v.img, 160)}" alt="" width="72" height="72" loading="lazy"></span><span class="nm">${esc(v.name)}</span></button>`).join("");
        return { picker: true, html: `<div class="ship-bar unlock"><span>${ICONS.truck}<span>Add 1 more mask: free shipping and pack price. ${nb("Only " + cents(moreC) + " more.")}</span></span><i><b style="--w:${pct}%"></b></i>
          <div class="ship-faces" data-ship-faces>${tiles}</div></div>` };
      }
    }
    return { picker: false, html: `<div class="ship-bar"><span>${ICONS.truck}<span>Add ${nb(cents(threshC - masksC) + " more")} for free US&nbsp;shipping</span></span><i><b style="--w:${pct}%"></b></i></div>` };
  }

  /* Shipping protection row: bold title, short blurb with a Details link, price, switch. Opt-in unless the setting says prechecked. */
  function protectRow(on) {
    return `<div class="protect slim${on ? " on" : ""}"><div class="t"><b>${PROTECT.title}</b></div>
      <div class="r"><span>${money(PROTECT.price)}</span><button class="switch" type="button" role="switch" aria-checked="${on}" data-protect aria-label="${PROTECT.title}, ${money(PROTECT.price)}"></button></div></div>`;
  }

  /* ---------- cart page ---------- */
  /* Server-rendered; this only enforces the protection rules and wires the switch and Remove link. */
  async function initCartPage() {
    const before = JSON.stringify((await cartFetch()).items.map((i) => [i.key, i.quantity]));
    if (PROTECT) {
      await normalizeProtection();
      if (JSON.stringify(CART.items.map((i) => [i.key, i.quantity])) !== before) { location.reload(); return; }
    }
    renderCartCount();
    const slot = $("#cart-ship"), lines = maskLines(), n = maskCount();
    if (slot && n) {
      const masksC = lines.reduce((t, l) => t + l.original_line_price, 0) - (CART.total_discount || 0);
      const threshC = Math.round(S.FREE_SHIPPING_THRESHOLD * 100), shippingC = masksC >= threshC ? 0 : Math.round(S.SHIPPING_FLAT * 100);
      const inCart = lines.map((l) => String(l.variant_id));
      const up = PRODUCT_LIST.map((p) => p.variants.find((v) => v.available && !inCart.includes(String(v.id)))).filter(Boolean)[0];
      slot.innerHTML = shipBar(lines, n, masksC, shippingC, Math.min(100, Math.round((masksC / threshC) * 100)), up).html;
      slot.addEventListener("click", async (e) => { const b = e.target.closest("[data-ship-faces] .sf"); if (!b) return; await addFace(b); location.reload(); });
    }
    document.addEventListener("click", async (e) => {
      const sw = e.target.closest("[data-protect-page]");
      const rm = e.target.closest("[data-protect-remove]");
      if (sw) { e.preventDefault(); sw.disabled = true; await setProtection(sw.getAttribute("aria-checked") !== "true"); location.reload(); }
      if (rm) { e.preventDefault(); await setProtection(false); location.reload(); }
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    const els = $$(".reveal:not(.in)"); if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("in")); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }), { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- stat numbers count up when the band enters (once, 900 ms, static under reduced motion) ---------- */
  function countUp(root) {
    const els = $$("[data-count]", root);
    if (!els.length || reduceMotion || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver((en) => {
      if (!en[0].isIntersecting) return;
      io.disconnect();
      els.forEach((el) => {
        const final = el.dataset.count; const m = final.match(/^([\d,]+(?:\.\d+)?)(.*)$/); if (!m) return;
        const target = parseFloat(m[1].replace(/,/g, "")), dec = (m[1].split(".")[1] || "").length, suffix = m[2], t0 = performance.now(), dur = 900;
        const step = (t) => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3), v = target * e; el.textContent = (dec ? v.toFixed(dec) : Math.round(v).toLocaleString()) + suffix; if (k < 1) requestAnimationFrame(step); else el.textContent = final; };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    io.observe(root);
  }

  /* ---------- trust strip: on phones the items scroll past as a slow ticker instead of hiding off-screen ---------- */
  function initTicker() {
    const ul = $(".trust-strip ul"); if (!ul || reduceMotion || !matchMedia("(max-width: 899px)").matches) return;
    const n = ul.children.length;
    ul.innerHTML += ul.innerHTML; ul.classList.add("marquee"); ul.setAttribute("aria-label", "Shipping, returns, fit and care");
    $$("li", ul).slice(n).forEach((li) => li.setAttribute("aria-hidden", "true"));
  }

  /* ---------- lightbox ---------- */
  function lightbox(src, caption) {
    let lb = $("#lightbox");
    if (!lb) { lb = document.createElement("figure"); lb.id = "lightbox"; lb.className = "lightbox"; lb.innerHTML = `<img alt=""><figcaption></figcaption><button aria-label="Close">✕</button>`; document.body.appendChild(lb); lb.addEventListener("click", () => lb.classList.remove("open")); }
    $("img", lb).src = src; $("figcaption", lb).textContent = caption || ""; lb.classList.add("open");
  }

  /* ---------- reviews ---------- */
  /* Launch mode on: only the live file is read and sample data is refused.
     Launch mode off (private preview): the sample file is shown. */
  let REVIEWS = null;
  const EMPTY = () => ({ reviews: [], summary: { average: 0, total: 0, distribution: {} } });
  async function loadReviews() {
    if (REVIEWS) return REVIEWS;
    const url = S.LAUNCH_MODE ? S.REVIEWS_LIVE : S.REVIEWS_SAMPLE;
    try { const r = await fetch(url, { cache: "no-store" }); REVIEWS = await r.json(); } catch (e) { REVIEWS = EMPTY(); }
    if (!REVIEWS || !Array.isArray(REVIEWS.reviews)) REVIEWS = EMPTY();
    if (S.LAUNCH_MODE && REVIEWS.sample) REVIEWS = EMPTY();
    /* Reviews for a product that is off the store (for example The Block Head) are not shown. */
    REVIEWS.reviews = (REVIEWS.reviews || []).filter((r) => !r.product || S.PRODUCTS[r.product]);
    return REVIEWS;
  }
  function reviewCard(r) {
    const sq = r.photo && /rv-(02|05|08)|flatlay|pro-lodge$|pro-chairlift$/.test(r.photo);
    return `<article class="review-card reveal">
      ${r.photo ? `<button class="photo ${sq ? "sq" : ""}" data-lb="${img(r.photo)}" data-cap="${r.name}, ${r.variant}"><img src="${img(r.photo)}" alt="Customer photo from ${r.name}" loading="lazy"></button>` : ""}
      <div class="body">
        <div class="who"><span>${r.name}</span>${r.verified ? `<span class="ok">${ICONS.check} Verified buyer</span>` : ""}</div>
        <div class="stars" aria-label="${r.rating} out of 5">${stars(r.rating)}</div>
        <h4>${r.title}</h4><p>${r.body}</p>
        <span class="var">Face: ${r.variant}${r.loc ? SEP + r.loc : ""}</span>
        <span class="date">${new Date(r.date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
      </div></article>`;
  }
  async function renderReviews(root, opts) {
    const data = await loadReviews();
    const all = data.reviews || [];
    const sum = data.summary || { average: 0, total: all.length, distribution: {} };
    const dist = sum.distribution || {};
    const total = sum.total || all.length;
    const writeHref = `mailto:${S.SUPPORT_EMAIL}?subject=${encodeURIComponent("My review")}`;
    if (!total) {
      root.innerHTML = `<div class="review-summary empty reveal"><div class="review-cta"><h3>Be the first to review.</h3><p>Reviews from verified orders will appear here.</p><a class="btn ghost" href="${writeHref}">Write a review</a></div></div>`;
      initReveal();
      return { data, total: 0, average: 0 };
    }
    let filterStar = 0, photosOnly = false, sort = "featured", shown = opts.initial || 9;
    const prodFilter = opts.product || "";
    root.innerHTML = `
      <div class="review-summary reveal">
        <div class="review-score"><div class="big">${sum.average.toFixed(1)}<small> / 5</small></div><div class="stars lg">${stars(sum.average)}</div><span class="muted small">Based on ${total.toLocaleString()} reviews</span></div>
        <div class="review-bars">${[5, 4, 3, 2, 1].map((s) => `<button data-star="${s}" aria-pressed="false"><span>${s} ★</span><i><b style="--w:${Math.round(((dist[s] || 0) / total) * 100)}%"></b></i><span>${(dist[s] || 0).toLocaleString()}</span></button>`).join("")}</div>
        <div class="review-cta"><h3>Real people, real lift lines.</h3><p>Every review comes from a verified order. The photos are the customers' own.</p><a class="btn ghost" href="${writeHref}">Write a review</a></div>
      </div>
      ${all.some((r) => r.photo) ? `<div class="review-photos" id="rv-photos"></div>` : ""}
      <div class="review-tools"><span class="count" id="rv-count"></span>
        <button class="toggle" id="rv-photo-toggle" aria-pressed="false">With photos</button>
        <label class="sr-only" for="rv-sort">Sort</label><select id="rv-sort"><option value="featured">Most helpful</option><option value="recent">Most recent</option><option value="high">Highest rating</option><option value="low">Lowest rating</option></select></div>
      <div class="review-grid" id="rv-grid"></div>
      <div class="review-more" id="rv-more"></div>`;
    const photosEl = $("#rv-photos", root);
    if (photosEl) photosEl.innerHTML = all.filter((r) => r.photo).slice(0, 14).map((r) => `<button data-lb="${img(r.photo)}" data-cap="${r.name}, ${r.variant}"><img src="${img(r.photo)}" alt="" loading="lazy"></button>`).join("");
    function list() {
      let L = all.slice();
      if (prodFilter) L = L.filter((r) => r.product === prodFilter);
      if (filterStar) L = L.filter((r) => r.rating === filterStar);
      if (photosOnly) L = L.filter((r) => r.photo);
      if (sort === "recent") L.sort((a, b) => new Date(b.date) - new Date(a.date));
      else if (sort === "high") L.sort((a, b) => b.rating - a.rating || b.helpful - a.helpful);
      else if (sort === "low") L.sort((a, b) => a.rating - b.rating || b.helpful - a.helpful);
      else L.sort((a, b) => (b.photo ? 1 : 0) - (a.photo ? 1 : 0) || b.helpful - a.helpful);
      return L;
    }
    function draw() {
      const L = list();
      $("#rv-count", root).textContent = L.length ? `Showing ${Math.min(shown, L.length)} of ${L.length.toLocaleString()} reviews` : "No reviews match this filter yet.";
      const grid = $("#rv-grid", root);
      grid.innerHTML = L.slice(0, shown).map(reviewCard).join("");
      $$(".reveal", grid).forEach((e, i) => { e.style.transitionDelay = (i % 6) * 40 + "ms"; });
      initReveal();
      $("#rv-more", root).innerHTML = L.length > shown ? `<button class="btn ghost" id="rv-more-btn">Load more reviews</button>` : "";
      const mb = $("#rv-more-btn", root); if (mb) mb.onclick = () => { shown += 9; draw(); };
    }
    root.addEventListener("click", (e) => {
      const st = e.target.closest("[data-star]");
      if (st) { const s = +st.dataset.star; filterStar = filterStar === s ? 0 : s; $$("[data-star]", root).forEach((b) => b.setAttribute("aria-pressed", String(+b.dataset.star === filterStar))); shown = opts.initial || 9; draw(); }
      const lb = e.target.closest("[data-lb]"); if (lb) lightbox(lb.dataset.lb, lb.dataset.cap);
    });
    $("#rv-photo-toggle", root).onclick = (e) => { photosOnly = !photosOnly; e.currentTarget.setAttribute("aria-pressed", String(photosOnly)); draw(); };
    $("#rv-sort", root).onchange = (e) => { sort = e.target.value; draw(); };
    draw();
    return { data, total, average: sum.average };
  }

  /* ---------- homepage ---------- */
  async function initHome() {
    const data = await loadReviews();
    const sum = data.summary || { average: 0, total: 0 };
    const hp = $("#hero-proof");
    if (hp) {
      if (sum.total) hp.innerHTML = `<span class="avatars">${(data.reviews || []).filter((r) => r.photo).slice(0, 3).map((r) => `<img src="${img(r.photo)}" alt="">`).join("")}</span><span class="stars">${stars(sum.average)}</span><span>${nb(`${sum.average.toFixed(1)} from ${sum.total.toLocaleString()} reviews`)}</span>`;
      else hp.remove();
    }
    /* Face cards are rendered by Liquid; the sample star line is added only when sample data is on. */
    const perVariant = {}; (data.reviews || []).forEach((r) => { perVariant[r.variant] = (perVariant[r.variant] || 0) + 1; });
    $$("[data-card-stars]").forEach((el) => {
      if (sum.total) el.innerHTML = `${stars(5)}<small>${(perVariant[el.dataset.cardStars] || 0) * 61 + 120}</small>`; else el.remove();
    });
    $$("[data-sample-only]").forEach((el) => { if (!sum.total) el.remove(); });
    const reels = $("#reels");
    if (reels) {
      const social = data.social;
      if (social && social.reels && !S.LAUNCH_MODE) {
        reels.innerHTML = social.reels.map((r) => `<a class="reel reveal" href="#" onclick="event.preventDefault();window.__toast('Reel opens on Instagram.')"><img src="${img(r.img)}" alt="" loading="lazy"><div class="ov"></div><span class="views">${ICONS.play.replace("<svg", '<svg style="fill:#fff"')} ${r.views}</span><span class="play">${ICONS.play}</span><div class="meta"><b>${r.handle}</b><span>${r.caption}</span></div></a>`).join("");
      } else reels.closest("section").remove();
    }
    const st = $("#stats");
    if (st) {
      if (data.social && data.social.customers && sum.total && !S.LAUNCH_MODE) {
        st.innerHTML = `<div class="stat"><b data-count="${data.social.customers}">${data.social.customers}</b><span>masks on mountains</span></div><div class="stat"><b data-count="${sum.average.toFixed(1)}\u2605">${sum.average.toFixed(1)}\u2605</b><span>average from ${nb(sum.total.toLocaleString() + " reviews")}</span></div><div class="stat"><b>${nb("30 days")}</b><span>no-drama returns</span></div>`;
        countUp(st);
      } else st.closest("section").remove();
    }
    const rv = $("#reviews-root"); if (rv) await renderReviews(rv, { initial: 9, product: "" });
    initReveal();
  }

  /* ---------- product page ---------- */
  function businessDays(from, n) { const d = new Date(from); let c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) c++; } return d; }
  const fmtDate = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric" });

  async function initProduct() {
    const P = window.STORE_PRODUCT; if (!P) return;
    const params = new URLSearchParams(location.search);
    const byParam = P.variants.find((v) => String(v.id) === params.get("variant")) || P.variants.find((v) => v.name.toLowerCase() === String(params.get("face") || "").toLowerCase());
    let vid = (byParam || P.variants.find((v) => String(v.id) === String(P.selected)) || P.variants[0]).id;
    /* Theme settings > Prices and packs > Pack selected when the product page opens (one place). */
    let bundleIdx = Math.max(0, S.BUNDLES.findIndex((b) => b.qty === Number(S.DEFAULT_PACK || 1)));
    let slots = [];
    const V = () => P.variants.find((v) => v.id === vid);
    const compareAt = S.COMPARE_AT && S.COMPARE_AT > S.BUNDLES[0].price ? S.COMPARE_AT : 0;

    /* gallery: media whose alt starts with the face name belong to that face; the rest is shared */
    const own = (v) => P.media.filter((m) => (m.alt || "").startsWith(v.name + " ") || (m.alt || "").startsWith(v.name + ","));
    const shared = P.media.filter((m) => !P.variants.some((v) => (m.alt || "").startsWith(v.name + " ") || (m.alt || "").startsWith(v.name + ",")));
    /* The packshot stays first (it is the LCP image); a video never leads the list. */
    const galleryList = () => {
      const v = V(); const list = own(v).length ? own(v).concat(shared) : [{ src: v.img, alt: v.name }].concat(shared);
      if (list[0] && list[0].type === "video") { const i = list.findIndex((m) => m.type !== "video"); if (i > 0) list.unshift(list.splice(i, 1)[0]); }
      return list;
    };
    /* mp4 rendition at or under 720p (short side, so portrait clips count right), the largest that fits; else the smallest mp4. */
    const short = (x) => Math.min(x.width || 0, x.height || 0);
    const pickSource = (m) => {
      const mp4 = (m.sources || []).filter((x) => /mp4/.test(x.mime_type || x.format || "")).sort((a, b) => short(a) - short(b));
      const fit = mp4.filter((x) => short(x) <= 720);
      return (fit.length ? fit[fit.length - 1] : mp4[0]) || null;
    };
    /* Headings: the last two words of the name are glued so "Faces" never stands alone on a line. */
    /* The PDP title stays on one line: CSS sizes it from --title-chars; this only corrects a rare overflow. */
    const titleEl = $("#title");
    titleEl.innerHTML = tmHtml(P.title);
    const fit = () => { titleEl.style.fontSize = ""; if (titleEl.scrollWidth > titleEl.clientWidth + 1) titleEl.style.fontSize = (parseFloat(getComputedStyle(titleEl).fontSize) * titleEl.clientWidth / titleEl.scrollWidth * 0.98).toFixed(2) + "px"; };
    fit(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    let fitT; addEventListener("resize", () => { clearTimeout(fitT); fitT = setTimeout(fit, 120); });
    const mainImg = $("#main-img"), thumbs = $("#thumbs"), mainBox = mainImg.parentNode, zoomBtn = $("#zoom");
    let current = 0;
    /* Product video: muted loop inline, plays only while on screen; reduced motion gets the poster and controls instead. */
    let vid0 = null, vidIO = null;
    function videoEl() {
      if (vid0) return vid0;
      vid0 = document.createElement("video");
      vid0.id = "main-video"; vid0.muted = true; vid0.loop = true; vid0.playsInline = true; vid0.preload = "metadata";
      vid0.setAttribute("muted", ""); vid0.setAttribute("playsinline", ""); vid0.setAttribute("loop", "");
      if (reduceMotion) vid0.controls = true; else vid0.setAttribute("autoplay", "");
      vid0.hidden = true; mainBox.insertBefore(vid0, mainImg.nextSibling);
      if (!reduceMotion && "IntersectionObserver" in window) {
        vidIO = new IntersectionObserver((en) => { if (vid0.hidden) return; if (en[0].isIntersecting) vid0.play().catch(() => {}); else vid0.pause(); }, { threshold: 0.35 });
        vidIO.observe(vid0);
      }
      return vid0;
    }
    function drawGallery() {
      const list = galleryList();
      thumbs.innerHTML = list.map((g, i) => `<button aria-current="${i === current}" aria-label="${g.type === "video" ? "Video" : "Image"} ${i + 1}"${g.type === "video" ? ' class="is-video"' : ""}><img src="${thumb(g.src, 160)}" alt="" loading="lazy" width="72" height="72">${g.type === "video" ? `<span class="glyph" aria-hidden="true">${ICONS.play}</span>` : ""}</button>`).join("");
      setMain(list[current], true);
    }
    function setMain(m, instant) {
      if (m.type === "video") {
        const v = videoEl(), srcObj = pickSource(m);
        v.poster = thumb(m.src, 1400); v.setAttribute("aria-label", m.alt || V().name);
        if (srcObj && v.dataset.src !== srcObj.url) { v.dataset.src = srcObj.url; v.src = srcObj.url; }
        v.hidden = false; mainImg.hidden = true; if (zoomBtn) zoomBtn.hidden = true;
        if (!reduceMotion) v.play().catch(() => {});
        return;
      }
      if (vid0) { vid0.pause(); vid0.hidden = true; }
      mainImg.hidden = false; if (zoomBtn) zoomBtn.hidden = false;
      const src = thumb(m.src, 1400), set = srcset(m.src);
      mainImg.alt = m.alt || V().name;
      if (instant || reduceMotion) { mainImg.srcset = set; mainImg.src = src; return; }
      mainImg.classList.add("swap");
      setTimeout(() => { mainImg.srcset = set; mainImg.src = src; mainImg.onload = () => mainImg.classList.remove("swap"); }, 160);
    }
    thumbs.addEventListener("click", (e) => { const b = e.target.closest("button"); if (!b) return; current = Array.from(thumbs.children).indexOf(b); $$("button", thumbs).forEach((x, i) => x.setAttribute("aria-current", String(i === current))); setMain(galleryList()[current]); });
    $("#zoom").addEventListener("click", () => lightbox(thumb(galleryList()[current].src, 1800), V().name));
    let sx = null; mainBox.addEventListener("pointerdown", (e) => (sx = e.clientX)); mainBox.addEventListener("pointerup", (e) => { if (sx === null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) < 40) return; const list = galleryList(); current = (current + (dx < 0 ? 1 : -1) + list.length) % list.length; $$("button", thumbs).forEach((x, i) => x.setAttribute("aria-current", String(i === current))); setMain(list[current]); });

    /* swatches */
    const sw = $("#swatches"); sw.classList.toggle("four", P.variants.length === 4);
    function drawSwatches() {
      sw.innerHTML = P.variants.map((v) => `<button class="swatch ${v.available ? "" : "sold-out"}" role="radio" aria-checked="${v.id === vid}" data-v="${v.id}"><span class="img"><img src="${thumb(v.img, 200)}" alt="" width="96" height="96"></span><span>${v.name}</span>${v.available ? "" : `<span class="so">Sold out</span>`}</button>`).join("");
      $("#swatch-name").textContent = V().name;
      const fs = $("#face-sub"); if (fs) fs.textContent = V().name;
    }
    sw.addEventListener("click", (e) => { const b = e.target.closest("[data-v]"); if (!b) return; vid = +b.dataset.v; current = 0; drawSwatches(); drawGallery(); drawSlots(); drawSticky(); drawPrice(); history.replaceState(null, "", `?variant=${vid}`); });

    /* bundles */
    const bl = $("#bundles");
    function drawBundles() {
      /* Each tier shows what it costs delivered. "Save" compares with buying the same number as separate single orders,
         shipping included, and says so. "Best value" only on the lowest price per mask. */
      /* Stacked offer cards: radio, title and a small subline on the left, price with the struck sum of singles on the
         right, tag chips on the card edge. "Best value" only on the lowest price per mask. */
      bl.innerHTML = S.BUNDLES.map((b, i) => {
        const ship = shipOn(b.price), pct = savePct(b), was = b.qty * S.BUNDLES[0].price;
        const best = b.qty > 1 && Math.abs(b.price / b.qty - BEST_PER) < 0.005;
        const saveAmt = Math.round((was - b.price) * 100) / 100;
        const sub = ship ? nb(`+ ${money(ship)} shipping`) : nb(money(b.price / b.qty) + " each");
        /* The smallest pack that ships free is the focal card: a solid green ribbon across its top, a green tint, and
           its saving spelled out with the free shipping. Other packs keep small chips. */
        const featured = b.qty === FREE_N && !ship;
        const saveLine = b.qty > 1 && saveAmt > 0 ? `<em class="save-line">${nb("Save " + money(saveAmt))}${featured ? "" : ` <span>(${pct}%)</span>`}</em>` : "";
        const tags = featured ? "" : (ship ? "" : `<span class="chip ok">Free shipping</span>`) + (best ? `<span class="chip ink">Best value</span>` : "");
        return `<div class="offer${i === bundleIdx ? " on" : ""}${featured ? " featured" : ""}" data-offer="${i}">${featured ? `<span class="ribbon">${ICONS.truck}Free shipping</span>` : ""}${tags ? `<span class="tags">${tags}</span>` : ""}<button class="bundle" type="button" role="radio" aria-checked="${i === bundleIdx}" data-i="${i}">
        <span class="radio ${MARKERS[i]}" aria-hidden="true"></span><span class="t"><b>${b.label}</b>${saveLine}<small>${sub}</small></span>
        <span class="p"><b>${money(b.price)}</b>${b.qty > 1 && pct ? `<s>${money(was)}</s>` : compareAt && b.qty === 1 ? `<s>${money(compareAt)}</s>` : ""}</span></button></div>`;
      }).join("");
      drawPrice();
    }
    bl.addEventListener("click", (e) => { const b = e.target.closest("[data-i]"); if (!b) return; bundleIdx = +b.dataset.i; $$("[data-i]", bl).forEach((x) => { x.setAttribute("aria-checked", String(+x.dataset.i === bundleIdx)); x.parentNode.classList.toggle("on", +x.dataset.i === bundleIdx); }); drawSlots(); drawPrice(); drawSticky(); });
    function drawPrice() {
      const b = S.BUNDLES[bundleIdx];
      const was = b.qty > 1 ? b.qty * S.BUNDLES[0].price : compareAt;
      const pn = $("#price-now");
      if (pn.textContent && pn.textContent !== money(b.price) && !reduceMotion) { pn.classList.remove("swap"); void pn.offsetWidth; pn.classList.add("swap"); }
      pn.textContent = money(b.price);
      $("#price-was").textContent = was ? money(was) : "";
      /* The deal: one pill with the saving in whole percent, rounded down (pack price against the sum of singles).
         A single mask shows the shipping it adds instead. */
      const ship = shipOn(b.price), pct = b.qty > 1 ? savePct(b) : (was ? Math.floor(((Math.round(was * 100) - Math.round(b.price * 100)) * 100) / Math.round(was * 100)) : 0);
      $("#price-deal").innerHTML = (pct > 0 ? `<span class="save-pill">Save ${pct}%</span>` : "") + (ship ? `<span class="ship-cost">${nb("+ " + money(ship) + " shipping")}</span>` : "");
      const freePack = S.BUNDLES.find((x) => x.qty === FREE_N);
      /* One mask selected: a tappable green bar that moves to the free-shipping pack. The amount is what that pack costs
         delivered minus what this one costs delivered (shipping included), so it is the real difference at checkout. */
      const freeIdx = S.BUNDLES.findIndex((x) => x.qty === FREE_N);
      if (b.qty < FREE_N && freeIdx > -1) {
        /* "Buy 2:" then two tappable badges. Green is shipping, blue is savings. The saving is the pack price against the
           sum of singles, the same number as the pack card. */
        /* Blue badge: how much off the 2nd mask is inside the 2-pack, in whole percent rounded down:
           (single - (pack price - single)) / single. With $24.99 and $39.98 that is exactly 40%. */
        const fp = S.BUNDLES[freeIdx], singleC = Math.round(S.BUNDLES[0].price * 100), extraC = Math.round(fp.price * 100) - singleC * (fp.qty - 1);
        const nthOff = singleC > 0 && extraC < singleC ? Math.floor(((singleC - extraC) * 100) / singleC) : 0;
        $("#price-per").innerHTML = `<span class="buy2"><span class="lbl">Buy ${fp.qty}:</span><button type="button" class="b2 ship" data-nudge="${freeIdx}" aria-label="Select ${fp.qty} masks, free shipping">${ICONS.truck}Free shipping</button>${nthOff > 0 ? `<button type="button" class="b2 save" data-nudge="${freeIdx}" aria-label="Select ${fp.qty} masks, ${nthOff}% off the ${fp.qty === 2 ? "2nd" : "last"} mask">${nb((fp.qty === 2 ? "2nd" : "Last") + " mask " + nthOff + "% off")}</button>` : ""}</span>`;
      } else $("#price-per").textContent = b.qty > 1 ? `${nb(money(b.price / b.qty) + " per mask")} with the ${nb(b.qty + "-pack")}, ${nb("free shipping")}` : FREE_LINE;
      $("#atc-total").innerHTML = `${was ? `<s>${money(was)}</s>` : ""}<b>${money(b.price)}</b>`;
      const avail = V().available;
      $("#atc").disabled = !avail; $("#sticky-atc").disabled = !avail;
      $("#atc .lbl").textContent = avail ? "Add to cart" : "Sold out";
    }
    $("#price-per").addEventListener("click", (e) => { const n = e.target.closest("[data-nudge]"); if (!n) return; const t = $(`[data-i="${n.dataset.nudge}"]`, bl); if (t) { t.click(); t.focus({ preventScroll: true }); } });
    /* face per slot for multi packs */
    const sp = $("#slots");
    function drawSlots() {
      const qty = S.BUNDLES[bundleIdx].qty;
      slots = Array.from({ length: qty }, (_, i) => slots[i] || vid); slots[0] = vid;
      sp.hidden = qty < 2;
      const host = $(`[data-offer="${bundleIdx}"]`, bl); if (host && sp.parentNode !== host) host.appendChild(sp);
      sp.innerHTML = `<div class="lead">Pick a face for each mask</div>` + slots.map((s, i) => `<div class="row"><span>Mask ${i + 1}</span><select data-slot="${i}" aria-label="Face for mask ${i + 1}" ${i === 0 ? "disabled" : ""}>${P.variants.map((v) => `<option value="${v.id}" ${v.id === s ? "selected" : ""} ${v.available ? "" : "disabled"}>${v.name}${v.desc ? ", " + v.desc : ""}</option>`).join("")}</select></div>`).join("");
    }
    sp.addEventListener("change", (e) => { const s = e.target.closest("[data-slot]"); if (s) slots[+s.dataset.slot] = +s.value; });

    /* delivery */
    /* Delivery promise: every number comes from Theme settings > Delivery promise. Ships by the latest processing day; the arrival window counts calendar days from there. */
    const now = new Date(), ship = businessDays(now, S.SHIP_MAX || 4), a1 = new Date(ship), a2 = new Date(ship);
    a1.setDate(a1.getDate() + (S.DELIVER_MIN || 8)); a2.setDate(a2.getDate() + (S.DELIVER_MAX || 15));
    const holiday = S.HOLIDAY_CUTOFF && new Date(S.HOLIDAY_CUTOFF + "T23:59:59") > now ? `<div>${ICONS.check}<span>${S.HOLIDAY_LINE}</span></div>` : "";
    const sb = $("#ships-by"); if (sb) sb.textContent = fmtDate(ship);
    /* Estimates only, never a guarantee: "Usually ships ... Arrives about ..." */
    $("#delivery").innerHTML = `<div>${ICONS.truck}<span>Usually ships within ${nb((S.SHIP_MIN || 2) + "-" + (S.SHIP_MAX || 4) + " business days")}. Arrives about <b>${nb(fmtDate(a1) + " - " + fmtDate(a2))}</b>.</span></div>${holiday}`;

    /* add to cart: one line per distinct face */
    async function addAll() {
      const qty = S.BUNDLES[bundleIdx].qty;
      const counts = {}; (qty > 1 ? slots : [vid]).forEach((s) => (counts[s] = (counts[s] || 0) + 1));
      const items = Object.keys(counts).map((k) => ({ id: Number(k), quantity: counts[k] }));
      const btn = $("#atc"); btn.disabled = true;
      try { await addToCart(items); } finally { btn.disabled = false; }
    }
    $("#atc").addEventListener("click", addAll);
    $("#sticky-atc").addEventListener("click", addAll);

    /* sticky bar */
    function drawSticky() {
      const b = S.BUNDLES[bundleIdx], was = b.qty > 1 ? b.qty * S.BUNDLES[0].price : 0, ship = shipOn(b.price);
      $("#sticky-img").src = thumb(V().img, 96); $("#sticky-name").innerHTML = tmHtml(P.title);
      $("#sticky-price").innerHTML = `${V().name}${SEP}${b.label}`;
      $("#sticky-deal").innerHTML = `<b>${money(b.price)}</b>${was ? `<s>${money(was)}</s><span class="save-pill sm">Save ${savePct(b)}%</span>` : ""}${ship ? `<small>${nb("Free shipping on " + FREE_N + "+")}</small>` : `<small>Free shipping</small>`}`;
    }
    const stickyEl = $("#sticky"), atcEl = $("#atc");
    if ("IntersectionObserver" in window) new IntersectionObserver((en) => { const e = en[0]; stickyEl.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0); }, { threshold: 0 }).observe(atcEl);

    /* rating line and popover: only with real or sample data, never invented */
    const data = await loadReviews();
    const sum = data.summary || { average: 0, total: 0, distribution: {} };
    const rt = $("#rating");
    if (sum.total) {
      const dist = sum.distribution || {};
      rt.innerHTML = `<button id="rating-btn" aria-expanded="false" style="display:inline-flex;gap:8px;align-items:center"><span class="stars">${stars(sum.average)}</span><u>${sum.average.toFixed(1)}${SEP}${nb(sum.total.toLocaleString() + " reviews")}</u></button>
        <div class="rating-pop" id="rating-pop" role="dialog" aria-label="Rating breakdown"><b>${sum.average.toFixed(1)} out of 5</b>${[5, 4, 3, 2, 1].map((s) => `<div class="row"><span>${s} ★</span><i><b style="--w:${Math.round(((dist[s] || 0) / sum.total) * 100)}%"></b></i><span>${Math.round(((dist[s] || 0) / sum.total) * 100)}%</span></div>`).join("")}<a class="link small" href="#reviews">Read all reviews</a></div>`;
      const btn = $("#rating-btn"), pop = $("#rating-pop");
      btn.onclick = (e) => { e.stopPropagation(); const o = pop.classList.toggle("open"); btn.setAttribute("aria-expanded", String(o)); };
      document.addEventListener("click", (e) => { if (!pop.contains(e.target)) { pop.classList.remove("open"); btn.setAttribute("aria-expanded", "false"); } });
      document.addEventListener("keydown", (e) => { if (e.key === "Escape") pop.classList.remove("open"); });
    } else rt.innerHTML = `<span class="muted small">New this season. Be the first to review.</span>`;

    /* Theme settings > Urgency: the same tick as the announcement bar fills this line. */
    const sl = $("#sale-line"); if (sl && S.URGENCY_TIMER && saleActive) sl.hidden = false;

    drawSwatches(); drawGallery(); drawBundles(); drawSlots(); drawSticky();
    const rv = $("#reviews-root"); if (rv) await renderReviews(rv, { initial: 9, product: P.key });
    initReveal();
  }

  /* ---------- upsell face tile: add, show "Added" briefly ---------- */
  async function addFace(tile) {
    const g = tile.closest("[data-ship-faces]"); $$(".sf", g).forEach((x) => (x.disabled = true));
    tile.classList.add("added"); $(".nm", tile).textContent = "Added";
    await cartAdd([{ id: Number(tile.dataset.face), quantity: 1 }]);
    await new Promise((r) => setTimeout(r, reduceMotion ? 300 : 650));
  }

  /* ---------- boot ---------- */
  renderAnnounce(); renderNav(); buildDrawer(); renderCartCount(); initTicker(); initReveal();
  if (page === "home") initHome();
  if (page === "product") initProduct();
  if (page === "cart") initCartPage();
  if (page !== "home" && page !== "product") { const rv = $("#reviews-root"); if (rv) renderReviews(rv, { initial: 9 }); }
  document.addEventListener("click", (e) => { const lb = e.target.closest("[data-lb]"); if (lb && !lb.closest("#reviews-root")) lightbox(lb.dataset.lb, lb.dataset.cap); });
  document.addEventListener("submit", (e) => { const f = e.target.closest("[data-toast-submit]"); if (f) { e.preventDefault(); window.__toast(f.dataset.toastSubmit); } });
})();
